// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D9oc87J8gpLvHl {
  margin-top: var(--ds-space-200, 16px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: var(--ds-space-150, 12px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `D9oc87J8gpLvHl`
};
export default ___CSS_LOADER_EXPORT___;
